import React from "react";

import { ComponentLayout } from "../../support/ComponentLayout";
import { ComponentSectionLayout } from "../../support/ComponentSectionLayout";

export const FormRangesDemo: React.FC<unknown> = () => {
  return (
    <ComponentLayout title={"Wip - Form Ranges"}>
      <ComponentSectionLayout title={"default"}></ComponentSectionLayout>
    </ComponentLayout>
  );
};
